import { Component, Input, OnChanges, Renderer2, RendererFactory2, SimpleChanges } from '@angular/core';
import { GeneralPopoverSettingsComponent } from '../general-popover-settings/general-popover-settings.component';
import { Subscription } from 'rxjs';
import { Block } from 'app/interfaces/blocks';
import { GlobalService } from 'app/global/global.service';
import { EventHandlersService } from '../../edit-template/event-handler.service';
import { IImageBoxSettingDTO, Positions } from './image-box-settings.dto';
import { ImagePosition } from 'app/interfaces/blocks';
@Component({
  selector: 'app-image-box-settings',
  templateUrl: './image-box-settings.component.html',
  styleUrl: './image-box-settings.component.scss',
  providers: [GeneralPopoverSettingsComponent]
})
export class ImageBoxSettingsComponent implements OnChanges {
  @Input() data: IImageBoxSettingDTO;
  public timeOutSubscription: Subscription;
  public imageData: Block;
  public selectedPosition: ImagePosition = 'center';
  private renderer: Renderer2;
  public positions: Positions[] = [
    { value: 'left', icon: 'align-left', tooltipKey: 'Image box settings button text (Template/Document - section) - Left' },
    { value: 'center', icon: 'align-center', tooltipKey: 'Image box settings button text (Template/Document - section) - Center' },
    { value: 'right', icon: 'align-right', tooltipKey: 'Image box settings button text (Template/Document - section) - Right' }
  ];
  constructor(
    private eventHandlersService: EventHandlersService,
    private globalService: GlobalService,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
     * listen the changes whenever call the component
     * @param changes 
     */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.data = changes['data'].currentValue;
      this.updateSettings();
    }
  }

  updateSettings() {
    this.imageData = this.globalService.fields_data['blocks'][this.data['uuid']];
    this.selectedPosition = this.imageData?.position ?? 'center';
  }

  setImagePosition(position: 'left' | 'center' | 'right') {
    this.selectedPosition = position;
    const selector = `.editor${this.data['uuid']} .content-selected-image`;
    const imageBox = document.querySelector(selector) as HTMLElement;

    if (!imageBox) return;

    // Remove old classes
    this.renderer.removeClass(imageBox, 'left');
    this.renderer.removeClass(imageBox, 'center');
    this.renderer.removeClass(imageBox, 'right');

    // Add new class
    this.renderer.addClass(imageBox, position);
    this.globalService.updateBlock(this.data['uuid'], { position: position });
  }

  /** Close external right menu */
  close() {
    this.eventHandlersService.triggerEditorSideMenu({}, 'DEFAULT');
  }
}
